import React, { useEffect, useState } from "react";
import { makeStyles, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@material-ui/core";
import Tooltip from "../../views/tool-tip";
import InputField from "../input-field/input-field";
import Error from "../../components/error";
import { checkValidationRule } from "../../utils/validate";
import clsx from "clsx";

const useStylesCheckbox = makeStyles({
  root: {
    background: "#BBDBE2",
    marginRight: "5px",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  iconMain: {
    color: "white",
    marginRight: "10px",
    fontSize: "22px",
  },
  rootDefault: {
    background: (props) => `${props.themecolors.lightBackgroundColor}`,
  },

  icon: {
    borderRadius: "50%",
    width: 18,
    height: 18,
    boxShadow: "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    //backgroundColor: "#8abbc7",1b283f
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 18,
      height: 18,
      backgroundImage: "radial-gradient(#F0F0F0,#F0F0F0 28%,transparent 32%)",
      content: '""',
    },
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
  },
  iconDefault: {
    backgroundColor: (props) => `${props.themecolors.borderColor}`,
  },

  checkedIcon: {
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 18,
      height: 18,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
  },
  checkedIconDefault: {
    backgroundColor: (props) => `${props.themecolors.onHoverTextColor}`,
    "input:hover ~ &": {
      backgroundColor: (props) => `${props.themecolors.onHoverTextColor}`,
    },
  },
});

const useStyles = makeStyles((theme) => ({
  formControl: {
    "&span": { fontSize: "large" },
    backgroundColor: "#fff",
    width: "100%",
    margin: "0",
    padding: "0px",
    borderRadius: "4px",
  },
  root: {
    backgroundColor: "#fff",
    padding: "6px",
    marginBottom: "4px !important",
    position: "relative",
    borderRadius: "2px",
  },
  secondLayout: {
    paddingLeft: "10px",
  },
  rootInherit: {
    //marginLeft: "20px",
  },
  formLabelroot: {
    display: "flex",
    paddingLeft: "0px !important",
    alignItems: "center",
    color: "#000 !important",
    fontSize: "14px",
    fontWeight: "bold !important",
  },
  formLabelrootInline: {
    paddingLeft: "4px ",
    color: (props) => `${props.themecolors.labelcolor} !important`,
    fontSize: "30px",
    padding: " 10px",
    fontWeight: "500",
    display: "flex",
  },
  rootInput: {
    maxWidth: "250px",
    marginLeft: "16px",
  },
  radiohvr: {
    "&:hover": {
      transform: "scale(1.03)",
    },
  },
  textBackGround: {
    backgroundColor: "#4094a9",
    color: "white",
    borderBottom: ".3px solid black",
  },
  untextBackGround: {
    backgroundColor: "#8cccdb",
    color: "white",
    borderBottom: ".3px solid black",
  },
  checkBoxDesignSelectedSurveySixth: {
    backgroundColor: (props) => `${props.themecolors.onSelectionbgcolor} !important`,
    color: (props) => `${props.themecolors.onHoverTextColor} !important`,
    transition: "0.3s",
    border: (props) => `${props.themecolors.onHoverBorder}`,
  },
  checkBoxDesignUnselectedSurveySixth: {
    backgroundColor: (props) => `${props.themecolors.lightBackgroundColor} !important`,
    color: (props) => `${props.themecolors.hoverOutColor} !important`,
    border: (props) => `${props.themecolors.border}`,
    transition: "0.3s",
    "&:hover": {
      backgroundColor: (props) => `${props.themecolors.onSelectionbgcolor} !important`,
      color: (props) => `${props.themecolors.onHoverTextColor} !important`,
      transition: "0.3s",
      border: (props) => `${props.themecolors.onHoverBorder}`,
      transform: "scale(1.03)",
    },
  },
}));

const StyledCheckbox = (props) => {
  const { theme, icon, templatetheme, displayicon, themecolors, id } = props;
  const classes = useStylesCheckbox({ themecolors });
  return (
    <div
      id={`${id}_div`}
      style={{
        fontSize: `${
          templatetheme === "1" ||
          templatetheme === "2" ||
          templatetheme === 1 ||
          templatetheme === 2
            ? "30px"
            : "25px"
        }`,
        height: `${
          templatetheme === "1" ||
          templatetheme === "2" ||
          templatetheme === 1 ||
          templatetheme === 2
            ? "45px"
            : "38px"
        }`,
        width: `${
          templatetheme === "1" ||
          templatetheme === "2" ||
          templatetheme === 1 ||
          templatetheme === 2
            ? "45px"
            : "38px"
        }`,
        borderRight: "1px solid  rgba(0,0,0,0.2) ",
        display: displayicon === "show" ? "inline-block" : "none",
        marginRight: "10px",
      }}
    >
      <Radio
        id={id}
        className={`${classes.root} ${theme ? classes.rootDefault : ""}`}
        disableRipple
        color="default"
        style={{ display: "none" }}
        checkedIcon={
          <span
            className={clsx(
              classes.icon,
              classes.checkedIcon,
              theme ? [classes.checkedIconDefault, classes.iconDefault] : ""
            )}
          />
        }
        icon={<span className={`${classes.icon}`} />}
        inputProps={{ "aria-label": "decorative checkbox" }}
        {...props}
      />
      <i className={`demo-icon ${icon} ${classes.iconmain}`}></i>
    </div>
  );
};

export default function DynamicRadioBox(props) {
  const { data, onChangeHandle, validateOptions, validate, validationCallback, value, name, type, themecolors, min, max, activestep,theme,displayicon,templatetheme } =
    props;

  const classes = useStyles({ themecolors });
  const [errors, setErrors] = useState({});
  const [checkedValue, setCheckedValue] = useState(value);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setCheckedValue(selectedValue);
    onChangeHandle(event);
    setErrors({});
  };

  const handleValidation = (errorMsg, isVisible, e) => {
    const err = { [name]: errorMsg };
    if (checkValidationRule(isVisible)) {
      setErrors(err);
    } else if (isVisible === "VALIDATE_ON_CLICK" && e.key !== "Enter") {
      setErrors({});
    }
    validationCallback(!!errorMsg);
  };

  const validateFields = (isVisible, e) => {
    const { required } = validateOptions;
    if (required) {
      let errorMsg = "";
      if (checkedValue === "" || checkedValue === "other") {
        errorMsg = `${name} is required`;
      }
      handleValidation(errorMsg, isVisible, e);
    } else {
      handleValidation("", isVisible, e);
    }
  };

  useEffect(() => {
    if (validate) {
      validateFields("VALIDATE_ON_FORM_SUBMIT");
    }
    setCheckedValue(value);
  }, [validate, value]);

  const [options, setOptions] = useState([]);

  const safeMin = min ? min : 1000;
  const safeMax = max ? max : 100000;

  useEffect(() => {
    const difference = safeMax - safeMin;
    const optionCount = difference < 100000 ? 4 : 8;

    // Step rounded to nearest 1000, ensure it's not zero
    const rawStep = difference / (optionCount - 1);
    const step = Math.max(Math.round(rawStep / 1000) * 1000, 1000);

    const generatedOptions = [];
    for (let i = 0; i < optionCount; i++) {
      let value = safeMin + step * i;
      if (value > safeMax) break;

      // Round to nearest 1000
      value = Math.round(value / 1000) * 1000;

      generatedOptions.push({
        label: value.toLocaleString(),
        value: value,
      });
    }

    setOptions(generatedOptions);
  }, [safeMin, safeMax]);

  const error = errors[name];
  const handleOnClick = (event) => {
    event.preventDefault();
    handleChange(event);
  };

  return (
    <div
      className={(classes.root, classes.radioHover)}
      style={{
        width: "100%",
        marginLeft: "0px",
      }}
    >
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel className={classes.formLabelrootInline}>
          {data.label}&nbsp;
          {validateOptions.required && type !== "survey" && <span className="mendatory">*</span>}
          {data.description && <Tooltip title={data.description} />}
        </FormLabel>

        <RadioGroup name={name} value={checkedValue} className={data.inline ? classes.root : classes.rootInherit}>
          {options.map((item, index) => (
            <FormControlLabel
              key={index}
              value={item.value}
              control={
                <StyledCheckbox
                  color="default"
                  theme={theme}
                  icon={displayicon === "show" ? item.icon : ""}
                  templatetheme={templatetheme}
                  displayicon={displayicon}
                  onClick={handleOnClick}
                  themecolors={themecolors}
                  id={`step_${activestep}_${name}_styledchk`}
                />
              }
              label={
                <div
                  className={
                    templatetheme === "2" && displayicon === "show"
                      ? `${classes.secondLayout}`
                      : ""
                  }
                  id={`step_${activestep}_${name}_div`}
                >
                  {item.label}
                </div>
              }
              id={`step_${activestep}_${name}_styledchk`}
              labelPlacement="end"
              className={`${classes.root} ${
                String(item.value).toLowerCase() === checkedValue.toLowerCase()
                  ? classes.checkBoxDesignSelectedSurveySixth
                  : classes.checkBoxDesignUnselectedSurveySixth
              }`}
              style={{
                padding: displayicon === "hide" ? "16px" : "",
              }}
            />
          ))}
        </RadioGroup>
        {error && <Error>{error}</Error>}
      </FormControl>
    </div>
  );
}
